import { format } from 'date-fns';
import { getQuarter } from 'date-fns';
import * as React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { showCarousel } from '../../../actions/miscellaneousActions';
import { IHistory } from '../../../interfaces';
import { DailyFormsModel } from '../../../model/DailyFormModel';
import { MonthlyFormModel } from '../../../model/MonthlyFormModel';
import { QuarterlyFormModel } from '../../../model/QuarterlyFormModel';
import { markAsComplete } from '../../../services/dailyFormService';
import { toDataUrl } from '../../../utils/generalUtils';
import { Async } from '../Async';
import { BasePage } from '../BasePage';
import { ErrorPage } from '../ErrorPage';
import { Gallery } from '../ImageGallery';
import { Img } from '../ImageGallery/Img';
import { Loader } from '../Loader';
import { MarkAsCompletedPopOver } from '../MarkAsCompletePopOver';
import './detailsPageWrapper.scss';
import './image-gallery.scss';
import { getFormDetailsByType } from '../../../services/dashboardService';
import { getDailyFormDetails } from '../../../services/dailyFormService';
import { getMonthlyFormDetails } from '../../../services/monthlyFormService';
import { getQuarterlyFormDetails } from '../../../services/quarterlyFormService';
import { startPromise } from '../../../actions/loadingActions';
declare var require: any;
const needsWorks = require('../../../images/needsWork.svg'); 
const loadingImage = require('./signLoading.gif');
import { imageExists } from '../../../services/formService';
import { convertAnswer } from '../../../constants/generals';

export interface IDetailsPageProps {
    id: string;
    promise: (...args: any[]) => any;
    history?: IHistory;
    instance: DailyFormsModel | MonthlyFormModel | QuarterlyFormModel;
    pageTitle: string;
    backTo: string;
    type?: string;
    formType: string;
}

export interface IDetailsPageState {
    isLoading: boolean;
    signBase64: string;
    styles: React.CSSProperties;
    quesNum: number;
}

export class DetailsPageImpl extends React.Component<IDetailsPageProps, IDetailsPageState> {

    constructor(props: IDetailsPageProps) {
        super(props);
        this.state = {
            signBase64: '', quesNum: null,
            isLoading: false, styles: {}
        };
    }

    refs: {
        popOver: MarkAsCompletedPopOver;
    };

    static defaultProps: IDetailsPageProps;

    renderPrintButton = () => {
        return <div
            className="button"
            onClick={this.handlePrint}
            id="print-button" >
            <i className="fa fa-print" aria-hidden="true"></i>
            &nbsp;
                <span> Print</span>
        </div>;
    }

    handleUpdate = async (comments, date) => {
        const { backTo, formType, instance: { props: { id, type } } } = this.props;
        const quarter = getQuarter(this.props.instance.props.questions[0].answer.toString());
        const queryString = `${backTo}?year=2018&&quarter=${quarter}&&region=All`;
        const data = quarter ? queryString : backTo;
        const { quesNum } = this.state;
        this.setState({
            isLoading: true
        });
        await markAsComplete(comments, id, type, quesNum, format(date, 'MM-DD-YYYY'), this);
        this.setState({
            isLoading: false
        });

        switch (formType) {
            case 'daily':
                await getDailyFormDetails(id);

                break;

            case 'monthly':
                await getMonthlyFormDetails(id, 'report');

                break;

            case 'quarterly':
                await getQuarterlyFormDetails(id);

                break;

            case 'flaggedforms':
                await getFormDetailsByType(id);

                break;

            default:
                break;
        }
    }

    renderMarkAsCompleteButton = () => {
        if (!this.props.instance || !this.props.instance.props.questions) {
            return <span />;
        }
        return <div style={{
            position: 'absolute',
            right: '20px',
        }}
            className="button"
            onClick={this.handlePrint}
            id="print-button" >
            <i className="fa fa-print" aria-hidden="true"></i>
            &nbsp;
                <span> Print</span>
        </div>;
        // }
    }

    handlePrint = () => {
        const { instance } = this.props;
        let formType = instance && instance.props.type || '';  
        let reportType = instance && instance.props.ReportType || '';
        
        document.getElementById('print-button').style.display = 'none';
        document.getElementById('back-button').style.display = 'none';
        if(formType == 'MonthlySPCC' && reportType == 'new') {
            document.getElementById('title-text').className = 'titleText-on-print';
        } 
        document.getElementById('details-page').className = 'details-page-container-on-print'; 
        if (document.getElementById('overlay')) {
            document.getElementById('overlay').style.display = 'none';
        }
        let css = '@page { size: portrait; margin: 0; }  body { margin: 10mm 0mm 0mm 0mm; } @media print { header,footer { display: none; } }',
            head = document.head || document.getElementsByTagName('head')[0],
            style = document.createElement('style');
        style.type = 'text/css';
        style.media = 'print';

        style.appendChild(document.createTextNode(css));
        head.appendChild(style);

        window.print();
        document.getElementById('back-button').style.display = 'block';
        document.getElementById('details-page').className = 'details-page-container';
        document.getElementById('title-text').className = '';
        document.getElementById('print-button').style.display = 'block';
        if (document.getElementById('overlay')) {
            document.getElementById('overlay').style.display = 'block';
        }
    }

    renderImages = () => {
        const { instance } = this.props;
        if (instance.props.ImageUrls.length <= 0) {
            return <img className="no-image" src={'noImage'} />;
        }
        return instance.props.ImageUrls.map((imageData, index) => {
            return <Img
                onClick={() => showCarousel(imageData)}
                key={index}
                style={{ padding: '5px' }}
                width="90px"
                height="75px"
                src={imageData}
            />;
        });

    }

    renderDeclaration = (formType) => {
        const { instance } = this.props; 
        return <PerfectScrollbar>
            <div className="right" >
                <div className="images-container" >
                    <div className="image-label" >Attached Images:</div>
                    <PerfectScrollbar>
                        <div className="attached-images">
                            {instance.props.ImageUrls.length > 0 ? instance.props.ImageUrls.map((url, index) => {
                                return <div
                                    key={index}
                                    title="Click to view in full screen mode."
                                    className="image"
                                >
                                    <Img src={url} onClick={() => showCarousel(url)} />
                                </div>;
                            }) : <div
                                style={{ fontSize: '16px', padding: '2vh 0', color: 'gray' }}
                            >
                                    No Image Attached to this form.
                    </div>
                            }
                        </div>
                    </PerfectScrollbar>
                </div>
            
                {formType === 'MonthlySW' || formType === 'ShopInspection' ?
                    <div>
                        <div style={{ paddingTop: '15px', paddingBottom: '15px', fontSize: '12px' }} >
                            I certify under penalty of law that this document and all attachments were
                    prepared under my direction or supervision in accordance with a system designed to
                    assure that qualified personnel properly gathered and evaluated the information
                    submitted. Based on my inquiry of the person or persons who manage the system, or those
                    persons directly responsible for gathering the information, the information submitted
                    is, to the best of my knowledge and belief, true, accurate, and complete. I am
                    aware that there are significant penalties for submitting false information,
                    including the possibility of fine and imprisonment for knowing violations.
            </div>

                        <div className="uploaded-signature-container">
                            <div className="image-label" >Attached Signature:</div>
                            {instance.props.SignatureUrls && instance.props.SignatureUrls.length > 0 /* && imageExists(instance.props.SignatureUrls) */ ?
                                <div className="signature-image" >
                                    <Async
                                        identifier="SignImage"
                                        promise={this.compressImage}
                                        loader={<img src={loadingImage} />}
                                        content={<img src={this.state.signBase64} />}
                                        error={<img src={loadingImage} />}
                                    />
                                </div> :
                                <div className="no-signature" >No Signature Attached</div>
                            }
                        </div>
                    </div> : <div></div>
                }
            </div>
        </PerfectScrollbar>;

    }

    compressImage = async () => {
        const self = this;
        const imgData = await toDataUrl(this.props.instance.props.SignatureUrls[0], (imgData) => {
            this.setState({
                signBase64: imgData
            });
        });
    }
    handleFollowUpForm = (instance) => {
        this.props.history.push(`/reports/monthly/${instance.props.Associations[0]}`);
        startPromise('DetailsPageWrapper');
    }
    renderFormDetails = () => {
        const { instance } = this.props;  
        let submittedByCount = 0;
        if (!instance || !instance.props.questions) {
            return <div></div>;
        } 
        let formType = instance && instance.props.type || '';  
        let reportType = instance && instance.props.ReportType || '';
        return <div style={{ padding: '20px' }} id="details-page" className="details-page-container" >
            <PerfectScrollbar>
                <div className="form-details" id="formDetails" > 
                    {instance.props.questions.map((questionData, index) => { 
                        if(questionData.question) {
                            if(questionData.question=='Submitted By') 
                                ++submittedByCount;
                            if( (questionData.question=='Submitted By' && submittedByCount==2) || questionData.question=='Date') {
                                return;
                            }
                            if(questionData.question=='Actions Taken' ) {
                                questionData.question = 'Actions Taken:';
                            } 
                        }
                       
                        return questionData ?
                            <div key={index} className="flagged-question-container">
                                {questionData.flaggedQuestion && !questionData.completed ?
                                    <MarkAsCompletedPopOver ref="popOver" onUpdate={this.handleUpdate} >
                                        <div
                                            className="mark-as-complete-col"
                                            title="Click to mark this question as Complete"
                                        >
                                            <i
                                                className="fa fa-check-square-o"
                                                onClick={() => this.setState({ quesNum: questionData.quesNum })}
                                                aria-hidden="true">
                                            </i>
                                        </div>
                                    </MarkAsCompletedPopOver>
                                    : ''}
                                <div className="question-col" >
                                    {!(questionData.answer && questionData.answer.indexOf('Needs work-') > -1) ? <Label
                                        icon={<i className="fa fa-flag" aria-hidden="true">&nbsp;</i>}
                                        isFlagged={questionData.flaggedQuestion}
                                    >
                                        {questionData.question}
                                    </Label> :
                                        <Label
                                            icon={<img style={{ height: '30px', width: '30px' }} src={needsWorks} />}
                                            isFlagged=
                                            {questionData.answer && questionData.answer.includes('Needs work')}
                                        >
                                            &nbsp;{questionData.question}
                                        </Label>
                                    }

                                    <Value reportType={reportType} formType={formType} >{ convertAnswer(questionData.answer) || 'Unanswered'}</Value>
                                    {(questionData.completed) ?
                                        [
                                            <Label
                                                icon={<i className="fa fa-check-circle" aria-hidden="true">&nbsp;</i>}
                                                key={1} isFlagged={1} >Completed By:
                                            </Label>,
                                            <Value reportType={reportType} formType={formType}  key={2}>{questionData.completedBy || 'NA'}</Value>,
                                            <span key={6} style={{ display: 'block', paddingBottom: '20px' }} />,
                                            <Label
                                                icon={<i className="fa fa-comments" aria-hidden="true">&nbsp;</i>}
                                                key={4} isFlagged={1} >Follow Up Comments:
                                            </Label>,
                                            <Value reportType={reportType} formType={formType}  key={5}>{questionData.followUpComments || 'NA'}</Value>,
                                            <span key={7} style={{ display: 'block', paddingBottom: '20px' }} />,
                                            <Label
                                                icon={<i className="fa fa-calendar" aria-hidden="true">&nbsp;</i>}
                                                key={8} isFlagged={1} >Date Completed:
                                            </Label>,
                                            <Value reportType={reportType} formType={formType}  key={9}>{questionData.dateCompleted || 'NA'}</Value>,
                                            <span key={10} style={{ display: 'block', paddingBottom: '20px' }} />
                                        ]
                                        : ''}

                                </div>
                            </div> : '';
                    })}
                    {instance.props.Associations && instance.props.Associations.length > 0 ?
                        <div className="form-footer">
                            <button className="followUpForm-button"
                                onClick={() => this.handleFollowUpForm(instance)}>
                                <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                &nbsp;    Show FollowUp Form
                    </button>
                        </div> : ''}
                </div>
            </PerfectScrollbar>
            {this.renderDeclaration(instance.props.type)}
        </div >;
    }

    render() {
        return (
            <BasePage sideButton={this.renderMarkAsCompleteButton()} pageTitle={this.props.pageTitle} >
                <Gallery images={this.props.instance ? this.props.instance.props.ImageUrls : []} />
                <Async
                    identifier="DetailsPageWrapper"
                    promise={this.props.promise}
                    loader={<Loader type="async" />}
                    error={<ErrorPage />}
                    content={this.renderFormDetails()}
                />
            </BasePage>
        );
    }
}

export function mapStateToProps(state) {
    return state;
}

export const DetailsPageWrapper
    = withRouter((connect<{}, {}, IDetailsPageProps>(mapStateToProps)(DetailsPageImpl as any)));

const Label = ({ children, isFlagged, icon }) => {
    return <div
        style={{ fontSize: '18px', color: `${isFlagged ? '#A4BF43' : 'gray'}` }}
    >
        {isFlagged ?
            icon
            : ''}
        {children}
    </div>;
};

const Value = ({ reportType, formType, children }) => { 
    const localStyle: React.CSSProperties = formType=='MonthlySPCC' && reportType=='new'? {fontSize: '17px', fontStyle: 'italic'} : { fontSize: '18px' }; 
    //const styles = Object.assign({}, style || {}, localStyle);  
    return <div style={localStyle}/* style={{ fontSize: '18px' }} */ >{children}</div>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/DetailsPageWrapper/index.tsx